import { useState as h, useEffect as E } from "react";
const o = 16, O = 60, j = (i, c, t) => {
  const [a, s] = h({
    accumulatedWidth: 0,
    index: 0
  }), [m, d] = h(!1);
  return E(() => {
    var r, n, u;
    if (Array.isArray(i) && i.length > 1 && t.current) {
      const W = ((n = (r = t.current) == null ? void 0 : r.firstChild) != null && n.childNodes ? Array.from(t.current.firstChild.childNodes) : []).map(
        (e) => e.clientWidth + o
      ), l = (((u = t.current) == null ? void 0 : u.clientWidth) || 0) - o - O, f = l * c > 0 ? l * c : 0, A = W.reduce(
        (e, g, p) => e.accumulatedWidth <= f ? (d(!1), {
          accumulatedWidth: e.accumulatedWidth + g,
          index: p
        }) : (d(!0), e),
        { accumulatedWidth: 0, index: 0 }
      );
      s(A);
    } else
      s({ accumulatedWidth: 0, index: 1 }), d(!1);
  }, [c, i, t]), { sizingObject: a, showMore: m };
};
export {
  j as useChipOverflow
};
//# sourceMappingURL=index.es5618.js.map
